import { createSelector } from 'reselect'
import { get } from 'lodash/fp'
import { Selector } from '../types/common'
import { IMessage } from '../types/message'
import { IMessagesState } from './messagesReducer'

export const messagesRootSelector: Selector<IMessagesState> =
  get('messages')

export const messageSelector = createSelector(
  messagesRootSelector,
  (root) => root.message,
)
